import { Flex, Text } from "@chakra-ui/react";
import { Table, ColumnDefinition } from "barte-design-system";
import { formatCurrency, formatDate } from "@/utils";

interface SplitData {
  idSplit: string;
  executionDate: string;
  subSellerName: string;
  providerType: string;
  amount: number;
}

const columns: ColumnDefinition<SplitData>[] = [
  {
    key: "executionDate",
    title: "Execução",
    dataIndex: "executionDate",
    render: (v) => formatDate(v as string) ?? "-",
  },
  {
    key: "subSellerName",
    title: "Destinatário",
    dataIndex: "subSellerName",
    render: (v) => v || "-",
  },
  {
    key: "providerType",
    title: "Destino",
    dataIndex: "providerType",
    render: (v) => v || "-",
  },
  {
    key: "amount",
    title: "Valor",
    dataIndex: "amount",
    render: (v) => formatCurrency({ value: v as number }),
  },
];

const SplitTable = ({ splitData }: { splitData: SplitData[] }) => {
  return (
    <Flex direction="column" gap="4" w="full">
      <Text fontWeight="bold" fontSize="16px" color="#0f172a">
        Split
      </Text>
      <Table
        data={splitData ?? []}
        columns={columns}
        rowKey={(r) => r.idSplit}
      />
    </Flex>
  );
};

export { SplitTable };
